export enum FloorplansBookingDetailEnum {
  GeneralInfo = 0,
  Bookings
}
